import { PostRequest } from "./http/BaseRequest";

export type MinerControlType =
  | "stop"
  | "start"
  | "restart"
  | "booston"
  | "boostoff"
  | "check"
  | "checkall";
export class MinerControlRequest extends PostRequest {
  constructor(contrl: MinerControlType, miners: string) {
    const params: any = {
      miner: miners,
      all: contrl === "checkall",
    };

    super(`/admin/miner/control/${contrl}`, params);
  }
}

export type MinerControlAction = "stop" | "start" | "restart" | "reset";
export const MinerControlRequestTyped = {
  makeRequest(ctrl: MinerControlAction, miners: number[]) {
    const url =
      ctrl === "reset" ? `/admin/miner/reset` : `/admin/miner/control/${ctrl}`;
    const m = miners.join(",");
    const params = ctrl === "reset" ? { id: m } : { miner: m };
    return new PostRequest(url, params);
  },
};

export class MinerReset extends PostRequest {
  constructor(miners: string) {
    const params: any = {
      id: miners,
    };

    super(`/admin/miner/reset`, params);
  }
}
